"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChartComponent = void 0;
var d3 = require("d3");
var React = require("react");
var react_1 = require("react");
var styles = require("../styles/PredictionModelResultsViz");
var colors = require("../util/colors");
var sizes = require("../util/sizes");
var utils_1 = require("../util/utils");
var BarChartComponent = function (props) {
    var title = props.title, description = props.description, hideBorder = props.hideBorder, data = props.data, xAxisLabel = props.xAxisLabel, yAxisLabel = props.yAxisLabel, color = props.color;
    var chartRef = react_1.useRef(null);
    // TODO: Will have default size for chart and the outer card!
    // Can create sizing file to support small, med, and maybe large versions
    var height = sizes.heightRegular;
    var width = sizes.widthRegular;
    var margin = sizes.chartMargins;
    var chartHeight = height - margin.top - margin.bottom;
    var chartWidth = width - margin.left - margin.right;
    // Create scales
    var yScale = d3
        .scaleLinear()
        .domain([0, d3.max(data.map(function (d) { return d.count; })) || 0])
        .range([height - margin.bottom, margin.top]);
    var xScale = d3
        .scaleBand()
        .domain(data.map(function (d) { return d.name; }))
        .rangeRound([margin.left, width - margin.right])
        .padding(0.1);
    var drawAxes = react_1.useCallback(function () {
        var svg = d3.select(chartRef.current);
        var xAxisTranslate = height - margin.bottom;
        var yAxisTranslate = margin.left;
        // TODO: Handle x-axis label overlap?
        var xAxis = d3.axisBottom(xScale).tickPadding(sizes.defaultTickPadding).tickSize(sizes.defaultTickSize);
        utils_1.drawAxis(svg, xAxis, 0, xAxisTranslate);
        var yAxis = utils_1.getLinearAxis(yScale, utils_1.AxisPosition.Left);
        utils_1.formatAxis(yAxis, 5, sizes.defaultTickSize, sizes.defaultTickPadding, utils_1.TickFormat.formatK);
        utils_1.drawAxis(svg, yAxis, yAxisTranslate, 0);
        var backgroundAxis = utils_1.getLinearAxis(yScale, utils_1.AxisPosition.Left);
        utils_1.formatAxis(backgroundAxis, 5, -chartWidth, sizes.defaultTickPadding, utils_1.TickFormat.hideNumbers);
        utils_1.drawAxisGridLines(svg, backgroundAxis, yAxisTranslate, 0);
    }, [chartWidth, height, margin, xScale, yScale]);
    var drawBars = react_1.useCallback(function () {
        var svg = d3.select(chartRef.current);
        svg
            .selectAll('rect')
            .data(data)
            .enter()
            .append('rect')
            .attr('x', function (d) { return xScale(d.name) || 0; })
            .attr('y', function (d) { return yScale(d.count) || 0; })
            .attr('transform', 'translate(0,' + margin.top.toString() + ')')
            .attr('width', xScale.bandwidth())
            .attr('height', function (d) { return chartHeight - (yScale(d.count) || 0); })
            .attr('fill', color || colors.defaultBlue);
    }, [chartHeight, color, data, margin, xScale, yScale]);
    react_1.useEffect(function () {
        d3.select(chartRef.current).selectAll('*').remove(); // To avoid stacking svg every re-render
        var svg = d3.select(chartRef.current).attr('height', height).attr('width', width);
        drawAxes();
        drawBars();
        utils_1.drawAxisLabel(svg, xAxisLabel || '', chartWidth / 2 + margin.left, sizes.chartFontSize);
        utils_1.drawAxisLabel(svg, yAxisLabel || '', sizes.chartFontSize, chartHeight / 2 + margin.top, true);
    }, [chartHeight, chartWidth, drawAxes, drawBars, height, margin, width, xAxisLabel, yAxisLabel]);
    return (React.createElement("div", { className: hideBorder ? styles.cardContainer : styles.cardContainer + ' ' + styles.cardBorderShadow },
        React.createElement("div", { className: hideBorder ? styles.card : styles.cardBorder + ' ' + styles.card },
            title && React.createElement("label", { className: styles.cardTitle }, title),
            description && React.createElement("label", { className: styles.cardDescription }, description),
            React.createElement("svg", { ref: chartRef }))));
};
exports.BarChartComponent = BarChartComponent;
//# sourceMappingURL=BarChartComponent.js.map